import { useState } from "react";
import { FaCheck } from "react-icons/fa";
import { supabase } from "../supabaseClient";
import SignupFormFields from "./Shared/SignupFormFields";
import InlineAlert from "./UI/DesignStandards/Notifications/InlineAlert";

const InviteSignupForm = ({ invite, onSuccess, onError }) => {
  const [formData, setFormData] = useState({
    displayName: "",
    email: invite?.email || "",
    phone: "",
    password: "",
    confirmPassword: "",
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [passwordChecks, setPasswordChecks] = useState({
    length: false,
    uppercase: false,
    lowercase: false,
    number: false,
    special: false,
  });

  const handleSubmit = async (e) => {
    setLoading(true);
    setErrors({});

    try {
      // First, create the user account using regular Supabase auth
      const { data: signupData, error: signupError } =
        await supabase.auth.signUp({
          email: formData.email.trim().toLowerCase(),
          password: formData.password,
          options: {
            data: {
              display_name: formData.displayName.trim(),
              phone_number: formData.phone.trim() || "",
            },
            emailRedirectTo: `${window.location.origin}/auth/callback`,
          },
        });

      if (signupError) {
        throw signupError;
      }

      if (!signupData.user) {
        throw new Error("Failed to create user account");
      }

      // Don't accept the invite here - let the email verification callback handle it
      // The user will be redirected to verify their email, and the auth callback
      // will automatically accept the invite and redirect to the organization

      onSuccess({
        user: signupData.user,
        message:
          "Account created successfully! Please check your email to verify your account and join the organization.",
      });
    } catch (error) {
      console.error("Error creating account:", error);

      let errorMessage = "Failed to create account. Please try again.";

      if (error.message?.includes("already exists")) {
        errorMessage =
          "An account with this email already exists. Please sign in instead.";
      } else if (error.message?.includes("expired")) {
        errorMessage = "This invitation has expired.";
      } else if (error.message?.includes("processed")) {
        errorMessage = "This invitation has already been used.";
      } else if (error.message?.includes("does not match")) {
        errorMessage = "Email does not match the invitation.";
      }

      onError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <SignupFormFields
      formData={formData}
      setFormData={setFormData}
      errors={errors}
      setErrors={setErrors}
      loading={loading}
      showPassword={showPassword}
      setShowPassword={setShowPassword}
      showConfirmPassword={showConfirmPassword}
      setShowConfirmPassword={setShowConfirmPassword}
      passwordChecks={passwordChecks}
      setPasswordChecks={setPasswordChecks}
      onSubmit={handleSubmit}
      submitButtonText="Create Account & Join Organization"
      submitButtonIcon={<FaCheck className="mr-2" />}
      showTerms={false}
    />
  );
};

export default InviteSignupForm;
